import { ACTIONS } from "../../../../Models/ENUM";
import CONQUER from "../../../CONQUER";
import FeedInstance from "../FeedInstance";
import FollowerInstance from "./FollowerInstance";

class Followers
{
    private conquer         : CONQUER;
    private feedInstance    : FeedInstance;

    public Membership       : any;

    public constructor( instance:CONQUER, feedInstance:FeedInstance ) 
    {
        this.conquer        = instance;
        this.feedInstance   = feedInstance;

        this.getMine();
    }

    public pool : any = [];

    /*=============== 


    GET
    

    ================*/

    private async getMine() : Promise<any>
    {
        this.Membership = new FollowerInstance( this.conquer, this.feedInstance, this.conquer.Avatars.ME );
        await this.Membership.get();
        return Promise.resolve();
    }

    public async get( force?:boolean ) : Promise<any> // pagination needed
    {
        if( this.pool.length && !force ) return Promise.resolve( this.pool );

        let array   = await this.conquer.do( ACTIONS.FOLLOWERS_GET, { _id:this.feedInstance.feedID } );
        this.pool   = [];

        for( var n in array ) this.pool.push( new FollowerInstance( this.conquer, this.feedInstance, array[n] ));
 
        return Promise.resolve( this.pool );
    };

    /*=============== 


    SET
    

    ================*/

    public async set() : Promise<any>
    {
        var friendship = await this.conquer.do( ACTIONS.FOLLOWERS_SET, { _id:this.feedInstance.feedID } );

        return Promise.resolve( friendship );
    };

    public async remove() : Promise<any>
    {
        var friendship = await this.conquer.do( ACTIONS.FOLLOWERS_REMOVE, { graphID:this.feedInstance.feedID } );

        return Promise.resolve( friendship );
    };


}

export default Followers;